<div>
  <div class="col-md-12 col-lg-12">
    <div class="col-sm-3"><h4><b>{{ "pages.createReceiptPage.shipmentItemPage.shipmentItems" | translate }}</b></h4></div>
    <div [@openClose]="!isOpen ? 'open' : 'closed'">
      <div class="col-sm-3">
        <h4>{{ "pages.createReceiptPage.shipmentItemPage.chargableWeight" | translate }} {{getTotalWeights().chargeWeights}}</h4>
      </div>
      <div class="col-sm-6"><h4 class="change  {{enableChange? '':'disabled'}}" (click)="change()">{{ "common.change" | translate }}</h4></div>
    </div>
  </div>
</div>
<div [@openClose]="!isOpen ? 'closed' : 'open'" class="col-md-12 col-lg-12">
  <table class="table">
    <thead>
      <tr>
        <th></th>
        <th>{{ "pages.createReceiptPage.shipmentItemPage.numberOfPieces" | translate }}</th>
        <th>{{ "common.length" | translate }}</th>
        <th>{{ "common.width" | translate }}</th>
        <th>{{ "common.height" | translate }}</th>
        <th>{{ "common.weight" | translate }} ({{BranchWeightUnit}})</th>
        <th>{{ "pages.createReceiptPage.shipmentItemPage.chargeWeight" | translate }} ({{BranchWeightUnit}})</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of shipmentItems; index as i">
        <td>
          <div *ngIf="item.chargeWeight !=''">
            <div class="row">
              <div class="col-md-4 col-sm-4">
                <i class="armx-icon  armx-edit" (click)="editShipment(i)"></i>
              </div>
              <div class="col-md-4 col-sm-4">
                <i *ngIf="i>0" (click)="deleteShipment(i)" class="armx-icon  armx-trash"></i>
                <i *ngIf="i==0" (click)="deleteShipment(i)" class="armx-icon armx-trash"></i>
              </div>
            </div>
          </div>
        </td>
        <td>
          <span *ngIf="item.chargeWeight !=''">{{fixDecimals(item.NoPieces)}}</span>
          <input (click)="$event.target.select()" *ngIf="item.chargeWeight ==''" class="form-control" name="NoPieces-{{i}}" type="number" [(ngModel)]="item.NoPieces" (blur)="calculate(item,i)" min="1" />
        </td>
        <td>
          <span *ngIf="item.chargeWeight !=''">{{fixDecimals(item.length)}}</span>
          <input (click)="$event.target.select()" *ngIf="item.chargeWeight ==''" class="form-control" name="length-{{i}}" type="number" [(ngModel)]="item.length" min="0"/>
        </td>
        <td>
          <span *ngIf="item.chargeWeight !=''">{{fixDecimals(item.width)}}</span>
          <input (click)="$event.target.select()" *ngIf="item.chargeWeight ==''" class="form-control" name="width-{{i}}" type="number" [(ngModel)]="item.width" min="0"/>
        </td>
        <td>
          <span *ngIf="item.chargeWeight !=''">{{fixDecimals(item.height)}}</span>
          <input (click)="$event.target.select()" *ngIf="item.chargeWeight ==''" class="form-control" name="height-{{i}}" type="number" [(ngModel)]="item.height" min="0"/>
        </td>
        <td>
          <span *ngIf="item.chargeWeight !=''">{{fixDecimals(item.weight)}}</span>
          <input (click)="$event.target.select()" *ngIf="item.chargeWeight ==''" class="form-control" name="weight-{{i}}" type="number" [(ngModel)]="item.weight" (blur)="calculate(item,i)" min="0"/>
        </td>
        <td><span>{{fixDecimals(item.chargeWeight) + ''}} </span></td>
      </tr>
      <tr *ngIf="shipmentItems[0].volWeight !=''">
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td><b>{{getTotalWeights().chargeWeights}}</b></td>
      </tr>
    </tbody>
  </table>
  <span [innerHtml]="validationMessage"></span>
  <div class="armx-btn-group">
    <button class="btn btn-default" (click)="addNewShipmentItem()">{{ "common.add" | translate }}</button>
    <button class="btn btn-primary {{disabled ? 'disabled' : ''}}" (click)="disabled ? false : getShipments()" [disabled]="disabled">{{ "common.done" | translate }}</button>
  </div>
  </div>

